import { defineStore } from 'pinia'
import qs from 'qs'
// @ts-ignore
import { useStrapi, useStrapiUser, useStrapiClient } from '#imports'
const { find } = useStrapi()
const user = useStrapiUser()

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    photoUrl: null,
    isLoadingPhoto: false,
  }),

  getters: {
    getPhotoUrl: (state) => state.photoUrl,
  },

  actions: {
    setUser(user) {
      this.user = user
    },

    setPhotoUrl(url) {
      this.photoUrl = url ? url + '?cacheblock=' + Date.now() : null
    },

    async fetchUpdatedPhoto(userId) {
      try {
        this.isLoadingPhoto = true
        const queryObj = {
          filters: { id: { $eq: userId } },
          fields: ['id'],
          populate: {
            profile: { fields: ['url', 'formats'] },
          },
        }

        const qr = qs.stringify(queryObj, { encodeValuesOnly: true })
        const query = `users?${qr}`

        const res = await find(query)

        if (res?.[0]) {
          // helper function to get best image version
          const profile = res[0]?.profile
          const imageUrl = profile?.formats?.thumbnail?.url || profile?.url || null
          this.setPhotoUrl(imageUrl)
        }
      } catch (error) {
        console.error('Error fetching updated photo:', error)
      } finally {
        this.isLoadingPhoto = false
      }
    }
  },
})
